import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@app/app.config';

@Injectable()
export class SendCookieInterceptor implements HttpInterceptor {
  constructor(@Inject(APP_CONFIG) protected appConfig: AppConfig) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.startsWith(this.appConfig.apiBaseUrl)) {
      return next.handle(req.clone({
        withCredentials: true,
      }));
    }

    return next.handle(req);
  }
}
